import { useRef } from "react";
import type { HlsVideoElement } from "hls-video-element";
import { useVideoControls } from "@circle-react-shared/MediaPlayer/VideoPlayer/hooks/useVideoControls";

export const usePlayer = () => {
  const videoRef = useRef<HlsVideoElement>(null);
  const { pause, seek } = useVideoControls({ videoRef });

  const duration = videoRef?.current?.duration || 0;

  return { videoRef, pause, seek, duration };
};
